import store from './store';
import { TextHelpers } from './textHelpers';
import * as webStorage from '@com.rakuten.esd/myr-web-storage';

export const getReAuthUrl = () => {
    const clientId = webStorage.getActiveClientId();
    const { CALLBACK_URL } = store.getState().app.appConfig;
    const locale = store.getState().app.locale;
    const prefix = store.getState().app.clientConfig.prefix;
    const lastVisitedPath = TextHelpers.setLastVisitedPathHandle(window.location.pathname, prefix);

    const url = new URL(CALLBACK_URL);
    url.pathname = `${url.pathname}reAuth`;
    url.searchParams.append('clientId', clientId);
    url.searchParams.append('lang', locale);
    url.searchParams.append('last_visited_path', lastVisitedPath);

    return url;
};
